import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
  buttonOutline: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    border: 'solid 1px #3560FF',
    borderRadius: '5px',
    width: '90px',
    height: '25px',
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontWeight: 700,
    fontSize: '12px',
    color: '#3560FF',
  },
}));
